import { ApplicationConfig } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";

export class ApplicationConfigService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<ApplicationConfig> {
    return fetchService
      .fetch(`${this.endpoint}/application-config`, {})
      .then((r) => r.json());
  }

  async persist(item: ApplicationConfig): Promise<ApplicationConfig> {
    return fetchService
      .fetch(`${this.endpoint}/application-config`, {
        method: "PUT",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }
}

const service = new ApplicationConfigService(env.endpoint);

export default service;
